import React, { useContext } from 'react';
import { TextsContext } from '../../context/textsContext';
import { BtnComponent } from '../../components/BtnComponent';
import { TitleH1Component } from '../../components/TitleH1Component';
import { ParagraphComponent } from '../../components/ParagraphComponent';
import MetricsSection from './components/MetricsSection';
import TableSection from './components/TableSection';
import style from '../../scss/dashboard.module.scss';

const DashboardPage = () => {
    const { texts } = useContext(TextsContext);

    return (
        <div className={`container ${style.dashboard}`}>
            <div className={style.header}>
                <div className={style.headerText}>
                    <TitleH1Component styleGroup={style.title}>
                        {texts?.dashboard_title ?? 'My Favorite Plan'}
                    </TitleH1Component>
                    <ParagraphComponent styleGroup={style.subtitle}>
                        {texts?.dashboard_subtitle ?? 'Here are your saved quotes'}
                    </ParagraphComponent>
                </div>
                <div className={style.headerActions}>
                    <BtnComponent to="/fav-plan/base-information" styleGroup={style.btnCreatePlan}>
                        {texts?.dashboard_create_plan ?? 'Create a New My Favorite Plan'}
                    </BtnComponent>
                </div>
            </div>

            <MetricsSection />

            <TableSection />
        </div>
    );
};

export default DashboardPage;
